import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Spin, Modal } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";
import { formatNumber, formatRupiah } from "../../Utils";
import downloadExcel from "../../../services/downloadExcel";
import ModalUpload from "./ModalUpload";

import { errorMessage } from "../../Utils";

let cancelToken;

class PriceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceList: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "update", direction: "desc" },
      visbleModalDownload: false,
    };
    this.addFileList = this.addFileList.bind(this);
  }

  componentDidMount() {
    this.fetchPriceList(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.area !== this.props.match.params.area) {
      this.setState(
        {
          isLoading: true,
          search: "",
          page: 1,
          limit: 15,
          sort: { name: "update", direction: "desc" },
        },
        () => this.fetchPriceList(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Brand") key = "brand";
    else if (sort.name === "Tipe") key = "type";
    else if (sort.name === "Spec") key = "spec";
    else if (sort.name === "Year") key = "year";
    else if (sort.name === "Price Max") key = "priceMax";
    else if (sort.name === "Price Min") key = "priceMin";
    else if (sort.name === "KM Max") key = "kmMax";
    else if (sort.name === "Harga Jual") key = "sellingPrice";
    else if (sort.name === "Ruang Nego") key = "ruangNego";
    else if (sort.name === "Hari/Tgl Dibuat") key = "create";
    else if (sort.name === "Hari/Tgl Update") key = "update";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  getArea() {
    let area = this.props.match.params.area;
    if (
      ![
        "jakarta",
        "bogor",
        "bandung",
        "karawang",
        "surabaya",
        "medan",
      ].includes(area)
    )
      area = null;
    return area;
  }

  async fetchPriceList(page, limit) {
    // const area = this.getArea();
    const area = this.props.match.params.area;
    if (area) {
      const order = this.orderBy(this.state.sort);
      const query = `${order}&page=${page}&limit=${limit}&search=${
        this.state.search || ""
      }`;

      if (cancelToken) {
        cancelToken.cancel("Operation canceled due to new request");
      }
      cancelToken = Axios.CancelToken.source();

      await axios
        .get(`admin-panel/price-list/${area}?${query}`, {
          cancelToken: cancelToken.token,
        })
        .then(result => {
          this.setState({
            priceList: result.data.priceList,
            page: result.data.page,
            limit: result.data.limit,
            count: result.data.count,
            isLoading: false,
          });
        })
        .catch(err => {
          if (!Axios.isCancel(err)) {
            errorMessage(err.response || err);
            this.setState({ isLoading: false });
          }
        });
    } else {
      this.setState({ isLoading: false });
      message.error("Gagal request data price list");
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchPriceList(page, limit);
  }

  getCar(data) {
    let car = {};

    if (data) {
      let { ValueCarSpec, AreaPricing } = data;

      //Year Area
      car = {
        ...car,
        year: data.year || null,
        kmMax: data.kmMax || null,
        priceMin: data.priceMin || null,
        priceMax: data.priceMax || null,
        sellingPrice: data.sellingPrice || null,
        ruangNego: data.ruangNego || null,
        area: AreaPricing ? AreaPricing.name : null,
      };

      //Spec
      if (ValueCarSpec) {
        let { ValueCarType } = ValueCarSpec;
        car.spec = ValueCarSpec.carSpec || null;

        //Type
        if (ValueCarType) {
          let { ValueCarBrand } = ValueCarType;
          car.type = ValueCarType.carType || null;

          //Brand
          if (ValueCarBrand) {
            car.brand = ValueCarBrand.brand || null;
          }
        }
      }
    }
    return car;
  }

  checkData(data) {
    return data ? data : null;
  }

  openModal() {
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false, fileList: null, disableButton: true });
  }

  addFileList(file) {
    this.setState({ fileList: file, disableButton: file ? false : true });
  }

  async downloadData() {
    const area = this.props.match.params.area;
    const data = await axios
      .get(`admin-panel/price-list/${area}?sort_by=brand&order_by=asc`)
      .then(result => {
        if (result.data.priceList && result.data.priceList.length > 0) {
          const priceList = result.data.priceList.map((item, idx) => {
            const {
              brand,
              type,
              spec,
              year,
              area,
              priceMin,
              priceMax,
              sellingPrice,
              kmMax,
              ruangNego,
            } = this.getCar(item);
            return {
              no: idx + 1,
              brand,
              type,
              spec,
              year,
              priceMin,
              priceMax,
              kmMax,
              hargaJual: sellingPrice,
              ruangNego,
              area,
            };
          });
          downloadExcel(priceList, `Price List - ${area}`);
        }
      })
      .catch(err => {
        message.error(err.response.message);
      });
  }

  async uploadData() {
    const { fileList } = this.state;
    if (fileList) {
      const area = this.props.match.params.area;
      this.setState({ confirmLoading: true });
      let formData = new FormData();
      formData.append("file", fileList);
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/admin-panel/price-list/${area}/update`,
        formData
      )
        .then(res => {
          message.success(`Berhasil Update Price List ${area}`);
          this.setState({
            confirmLoading: false,
            openModal: false,
            isLoading: true,
            fileList: null,
            disableButton: true,
          });
          this.fetchPriceList(1, this.state.limit);
        })
        .catch(e => {
          if (e.response) {
            if (e.response.data || e.response.message) {
              message.error(
                e.response.data.message || e.response.message || e.response.data
              );
            } else {
              message.error("Please upload only csv file.");
            }
          } else {
            message.error("Please upload only csv file.");
          }
          this.setState({ confirmLoading: false });
        });
    } else {
      message.error("Silahkan pilih file CSV terlebih dahulu");
    }
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "No",
        options: {
          sort: false,
        },
      },
      {
        name: "Brand",
        options: {
          sort: true,
        },
      },
      {
        name: "Tipe",
        options: {
          sort: true,
        },
      },
      {
        name: "Spec",
        options: {
          sort: true,
        },
      },
      {
        name: "Year",
        options: {
          sort: true,
        },
      },
      {
        name: "Price Min",
        options: {
          sort: true,
        },
      },
      {
        name: "Price Max",
        options: {
          sort: true,
        },
      },
      {
        name: "KM Max",
        options: {
          sort: true,
        },
      },
      {
        name: "Harga Jual",
        options: {
          sort: true,
        },
      },
      {
        name: "Ruang Nego",
        options: {
          sort: true,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Dibuat",
        options: {
          sort: true,
        },
      },
      {
        name: "Hari/Tgl Update",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const priceList = this.state.priceList.map((item, idx) => {
      const {
        brand,
        type,
        spec,
        year,
        priceMin,
        priceMax,
        kmMax,
        area,
        sellingPrice,
        ruangNego,
      } = this.getCar(item);
      return [
        this.state.limit * (this.state.page - 1) + (idx + 1),
        this.checkData(brand),
        this.checkData(type),
        this.checkData(spec),
        this.checkData(year),
        formatRupiah(priceMin),
        formatRupiah(priceMax),
        formatNumber(kmMax),
        formatNumber(sellingPrice),
        formatNumber(ruangNego),
        this.checkData(area),
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Harga Beli / Jual"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.downloadData()}>Download Data</Button>

          <Button onClick={() => this.openModal()} style={{ marginLeft: 10 }}>
            Upload Data
          </Button>
        </div>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={`Harga Beli / Jual - ${this.props.match.params.area}`}
              data={priceList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <Modal
          visible={this.state.openModal}
          title="Upload Data Harga Beli / Jual"
          onOk={() => this.uploadData()}
          onCancel={() => this.closeModal()}
          confirmLoading={this.state.confirmLoading}
          okButtonProps={{ disabled: this.state.disableButton }}>
          <ModalUpload fileList={this.addFileList} />
        </Modal>
      </Card>
    );
  }
}

export default PriceList;



// WEBPACK FOOTER //
// src/components/Dashboard/PriceList/PriceList.js